import React,{useContext} from 'react'
import {useSelector} from 'react-redux'

const Toggle = () => {
  const {map} = useSelector(s=>s.map)
  return (
    <div id="sb-toggle" onClick={()=>{
      document.querySelector('#map').classList.toggle("open");
      document.querySelector('#sidebar').classList.toggle("open");
      setTimeout(()=>{
        map.updateSize()
      },270)
    }}><i></i></div>
  )
}
export default Toggle
